var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      class: ((_obj = { company: _vm.company, enabled: _vm.subExpireDate }),
      (_obj[_vm.company] = _vm.company),
      _obj),
      attrs: { to: "/company/" + _vm.company, tag: "button" }
    },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/static/companies/" + _vm.company + ".svg" }
      }),
      _vm._v(" "),
      _vm.subExpireDate
        ? _c("div", { staticClass: "remaining" }, [
            _c("span", { staticClass: "day" }, [
              _vm._v(_vm._s(_vm.subExpireDate))
            ]),
            _vm._v(" Days\n\t")
          ])
        : _vm._e()
    ]
  )
  var _obj
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-471c6d4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471c6d4b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Company.vue
// module id = null
// module chunks = 